<!--
描述：选择用户组件，附带左侧机构树
作者：wangjing.dc@qq.com
时间：2022-10-5

-->
<template>
  <div>
    <a-input-search
      v-model="userNames"
      placeholder="请先选择用户"
      readOnly
      unselectable="on"
      @search="onSearchDepUser">
      <a-button slot="enterButton" :disabled="disabled">选择用户</a-button>
    </a-input-search>
    <select-user-by-dep-modal ref="selectModal" :modal-width="modalWidth" :multi="multi" @ok="selectOK" :user-ids="value" />
  </div>
</template>

<script>
  import SelectUserByDepModal from './modal/XSelectUserByDepModal'
  import {getUserList} from '@/api/api'

  export default {
    name: 'JSelectUserByDep',
    components: {SelectUserByDepModal},
    props: {
      modalWidth: {
        type: Number,
        default: 1250,
        required: false
      },
      value: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      multi: {
        type: Boolean,
        default: true,
        required: false
      },
    },
    data() {
      return {
        userIds: "",
        userNames: ""
      }
    },
    mounted() {
      this.userIds = this.value
      this.initUsernames(this.value);
    },
    watch: {
      value(val) {
        this.userIds = val
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    methods: {
      initUsernames(userIds) {
        let values = userIds.split(',') + ','
        getUserList({
          username: values,
          pageNo: 1,
          pageSize: values.length
        }).then((res) => {
          if (res.success) {
            let realNames = []
            res.result.records.forEach(user => {
              realNames.push(user['realname'])
            })
            this.userNames = realNames.join(',')
            console.info('初始化JSelectUserByDep默认用户', this.userNames)
          }
        })
      },
      onSearchDepUser() {
        this.$refs.selectModal.showModal()
      },
      selectOK(rows, idstr) {
        console.log("当前选中用户", rows)
        console.log("当前选中用户ID", idstr)
        if (!rows) {
          this.userNames = ''
          this.userIds = ''
        } else {
          let temp = ''
          for (let item of rows) {
            temp += ',' + item.realname
          }
          this.userNames = temp.substring(1)
          this.userIds = idstr
        }
        this.$emit("change", this.userIds)
      }
    }
  }
</script>

<style scoped>

</style>